import styled, { css } from 'styled-components';

import Button from '@components/Button/next';

// Common Style for date-range and single-date-range

export const DatePickerWrapper = styled.div<{ isPadding?: boolean }>`
  height: 100%;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: ${({ isPadding }) => (isPadding ? '0px 10px' : '0px')};
  &::-webkit-scrollbar {
    display: none;
  }
  .CalendarDay__selected_span {
    background-color: rgba(250, 88, 81, 0.2);
    color: ${({ theme }) => theme.palette.black};
  }
  .CalendarDay__hovered_span {
    background-color: rgba(250, 88, 81, 0.2);
    color: ${({ theme }) => theme.palette.black};
  }
  .CalendarDay__default {
    border: none !important;
    border-radius: 8px;

    &:not(.CalendarDay__blocked_out_of_range):hover {
      background-color: ${({ theme }) => theme.palette.coral};
      color: white;

      & span {
        background-color: ${({ theme }) => theme.palette.coral};
        color: white;
      }
    }
  }
  .CalendarDay__today :not(.CalendarDay__selected) {
    background: linear-gradient(
        to bottom right,
        transparent 90%,
        ${({ theme }) => theme.palette.coral} 0
      ),
      ${({ theme }) => theme.palette.white};
    :hover {
      background: ${({ theme }) => theme.palette.coral};
      background-color: ${({ theme }) => theme.palette.coral};
    }
  }

  .CalendarDay__today.CalendarDay__selected {
    background: ${({ theme }) => theme.palette.coral};
    background-color: ${({ theme }) => theme.palette.coral};

    & span {
      background: 0px ${({ theme }) => theme.palette.coral};
    }
  }

  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background-color: ${({ theme }) => theme.palette.coral} !important;
    background: ${({ theme }) => theme.palette.coral} !important;
    color: white;
    cursor: pointer;
  }

  .DayPicker_weekHeader_li {
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.brownishGrey};
    :nth-last-child(-n + 2) {
      color: ${({ theme }) => theme.palette.clearBlue};
    }
  }

  .CalendarMonth_caption > strong {
    color: ${({ theme }) => theme.palette.coral};
    font-size: 14px;
  }

  .DayPickerNavigation_1,
  .DayPickerNavigation__vertical {
    top: -8px !important;
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
      position: fixed !important;
      display: none !important;
    }
  }

  .CalendarMonthGrid,
  .CalendarMonthGrid_1,
  .CalendarMonthGrid__horizontal,
  .CalendarMonthGrid__horizontal_2 {
    height: 100%;
    width: 100%;
    left: 15px;
    @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
      margin-top: 10px;
    }
  }

  .DayPicker,
  .DayPicker_1,
  .DayPicker__horizontal,
  .DayPicker__horizontal_2 {
    width: 100% !important;
    box-shadow: none;
    border-radius: 0px;
  }
  .DayPicker_transitionContainer_1 {
    min-height: 285px;
  }
  .CalendarMonth_table {
    margin-top: 10px;
  }

  .DayPicker_weekHeader__verticalScrollable {
    padding: 0px !important;
  }
  .DayPickerKeyboardShortcuts_buttonReset {
    display: none;
  }
`;

const NavButtonMixin = css`
  position: absolute;
  top: 20px;
`;

export const NavPrevButton = styled(Button)`
  ${NavButtonMixin}
  left: 18px;
`;

export const NavNextButton = styled(Button)`
  ${NavButtonMixin}
  right: 18px;
`;

export const ResponsiveNavDownButton = styled(Button)`
  ${NavButtonMixin}
  width: 100%;
  height: 40px;
  z-index: 200;
  cursor: pointer !important;
  user-select: none !important;
  margin: 0px !important;
  border-radius: 0;
  border-width: 1px 1px 1px 0px !important;
  border-top-style: solid !important;
  border-right-style: solid !important;
  border-bottom-style: solid !important;
  border-top-color: rgb(228, 231, 231) !important;
  border-right-color: rgb(228, 231, 231) !important;
  border-bottom-color: rgb(228, 231, 231) !important;
  border-image: initial !important;
  color: rgb(117, 117, 117) !important;
  padding: 5px !important;
  background: rgb(255, 255, 255) !important;
  box-shadow: rgb(0 0 0 / 10%) 0px 0px 5px 2px !important;
  position: relative !important;
  display: inline-block !important;
  text-align: center !important;
  height: 100% !important;
  border-left-style: initial !important;
  border-left-color: initial !important;
  width: 100% !important;
  top: 8px;
  padding-bottom: 8px !important;

  & span {
    justify-content: center;
  }
`;

export const ResponsiveDatePickerWrapper = styled.div`
  display: contents;
`;
export const CheckboxContainer = styled.div<{ checkColor?: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: auto;
  height: 36px;
  width: 164px;
  padding: 8px;
  background-color: ${({ theme, checkColor }) =>
    checkColor ? theme.palette.R50 : theme.palette.NL20};
  border-radius: 8px;
  input[type='radio']:not(old) {
    display: inline-block;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border-radius: 1em;
    margin-right: 4px;
    border: 2px solid ${(p) => p.theme.palette.darkGray};
  }

  input[type='radio']:not(old):checked {
    background-image: radial-gradient(
      circle at center,
      ${(p) => p.theme.palette.burntSienna},
      ${(p) => p.theme.palette.burntSienna} 37.5%,
      ${(p) => p.theme.palette.white} 40%,
      ${(p) => p.theme.palette.white} 100%
    );
  }
`;
export const CheckboxContainerMobile = styled.div<{ checkColor?: boolean }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: auto;
  height: 36px;
  padding: 8px;
  background-color: ${({ theme, checkColor }) =>
    checkColor ? theme.palette.R50 : theme.palette.NL20};
  border-radius: 8px;
  input[type='radio']:not(old) {
    display: inline-block;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border-radius: 1em;
    margin-right: 4px;
    border: 2px solid ${(p) => p.theme.palette.darkGray};
  }

  input[type='radio']:not(old):checked {
    background-image: radial-gradient(
      circle at center,
      ${(p) => p.theme.palette.burntSienna},
      ${(p) => p.theme.palette.burntSienna} 37.5%,
      ${(p) => p.theme.palette.white} 40%,
      ${(p) => p.theme.palette.white} 100%
    );
  }
`;
export const RadioButton = styled.input`
  width: 18px;
  height: 18px;
`;
export const HolidayCard = styled.div`
  min-height: 72px;
  width: 164px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.NL40};
  padding: 8px;
  display: grid;
  grid-template-rows: 1fr;
  cursor: pointer;
`;
export const HolidayCardMobile = styled.div`
  min-height: 72px;
  width: auto;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.NL40};
  padding: 8px;
  display: grid;
`;
export const Title = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.D400};
`;
export const Year = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.D100};
`;
export const Icon = styled.div`
  color: ${({ theme }) => theme.palette.D100};
`;
export const Dates = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.D400};
  background-color: ${({ theme }) => theme.palette.BR50};
  max-height: 23px;
  border-radius: 8px;
  max-width: max-content;
  padding: 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const Description = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.G300};
  background-color: ${({ theme }) => theme.palette.G50};
  max-height: 23px;
  border-radius: 4px;
  width: fit-content;
  padding: 4px;
  margin-top: 8px;
`;
export const Holiday = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(1px, 170px));
  background-color: ${({ theme }) => theme.palette.white};
  padding: 16px;
  cursor: default;
`;
export const MobileHoliday = styled.div`
  display: grid;
  gap: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  cursor: default;
`;
export const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px 16px 0px 16px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 10px 0px 10px 0px;
  }
`;
export const WeekHoliday = styled.div`
  padding: 16px;
  cursor: default;
`;
export const WeekHolidayMobile = styled.div`
  padding: 0px;
  cursor: default;
`;
export const WeekHolidayCard = styled.div`
  min-height: 33px;
  width: max-content;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.NL40};
  padding: 8px;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  cursor: pointer;
`;
export const DateWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
`;
export const DateContainer = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
export const YearWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
`;
export const YearContainer = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
export const HolidayContainer = styled.div`
  align-items: flex-start;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
export const Container = styled.div``;
export const Div = styled.div<{ holidayData?: boolean }>`
  padding: 10px 16px 16px 16px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    position: fixed;
    bottom: ${({ holidayData }) => (holidayData ? '40px' : '10px')};
    background-color: ${({ theme }) => theme.palette.white};
    width: 120%;
    padding: 10px 10px 16px 10px;
    border-top: 1px solid ${({ theme }) => theme.palette.NL30};
    left: -10px;
    margin: 10px;
  }
`;
export const DayPicker = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.BR300};
  font-weight: bolder;
`;
export const HolidayName = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.D100};
`;

export const LineContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 0px 16px 0px 16px;
`;
export const Line = styled.div`
  background-color: ${({ theme }) => theme.palette.NL30};
  height: 1px;
  width: 100%;
`;
export const Circle = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.palette.BR300};
`;
export const RadioText = styled.div<{ selected?: boolean }>`
  font-size: 12px !important;
  font-weight: ${({ selected }) => (selected ? '900' : '400')};
  color: ${({ theme }) => theme.palette.D400};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
export const MonthText = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.D400};
  display: flex;
  justify-content: start;
  min-width: 60px;
  height: 36px;
  padding: 6px 0px;
  align-items: center;
`;
export const MonthWrapper = styled.div`
  display: flex;
`;
